module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "index-bar"
  }, [_c('ul', {
    attrs: {
      "id": "index-bar-ul"
    },
    on: {
      "touchstart": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.indexBarStart($event)
      },
      "touchmove": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.indexBarMove($event)
      },
      "touchend": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.indexBarEnd($event)
      }
    }
  }, _vm._l((_vm.character), function(v, k, i) {
    return _c('li', {
      key: i
    }, [_vm._v(_vm._s(v))])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e4a45088","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/IndexBar.vue
// module id = 881
// module chunks = 0